import { render, staticRenderFns } from "./view-ordonnance.html?vue&type=template&id=797cff6e&scoped=true&external"
import script from "./view-ordonnance.js?vue&type=script&lang=js&external"
export * from "./view-ordonnance.js?vue&type=script&lang=js&external"
import style0 from "./view-ordonnance.scss?vue&type=style&index=0&id=797cff6e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797cff6e",
  null
  
)

export default component.exports